<template>
  <div class="">
      <h1 class="text-muted mb-4">
		<vue-fontawesome class="mr-2" icon="user"></vue-fontawesome>
          System Users
      </h1>
      <!-- list users -->
      <section>
          <div class="d-flex justify-content-between">
              <div>
                  <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                      <li class="nav-item">
                          <a class="nav-link active" 
                              id="pills-home-tab" 
                              data-toggle="pill" 
                              href="#pills-home" 
                              role="tab" 
                              aria-controls="pills-home" 
                              aria-selected="true">
                                                      
                              System users
                          </a>
                      </li>
                  </ul>
              </div>
          </div>	

          <div class="tab-pane fade show active" 
              id="pills-home" 
              role="tabpanel" 
              aria-labelledby="pills-home-tab">
              <div class="mb-4 d-flex justify-content-between p-2">
                  <!-- right -->
                  <section class="d-flex">
                      <span class="p-2 font-weight-bold" v-if="users">
                          <span class="text-muted">Found</span> {{users.length}}
                      </span>
                      <div class="dropdown">
                          <a class="btn btn-light dropdown-toggle" 
                              href="#" role="button" id="dropdownMenuLink" 
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Filters
                          </a>
                          
                          <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                  <div class="form-group d-flex justify-content-between">
                                      <label class="p-2">Search</label>
                                      <input type="text" class="col-8 form-control" v-model="search"> 
                                  </div> 												                                   
                                  <div class="ml-2 d-flex justify-content-end">
                                      <button class="btn btn-outline-success"  @click="getUsers()">
                                          Get users
                                      </button>
                                  </div>	
                          </div>
                      </div>
                      <div class="ml-2">
                        <button class="btn btn-outline-success" 
							@click="$exportTable('usersTable','users.csv')">
								Export to CSV
						</button>	
                      </div>	
                  </section>  
                  <!-- add buttons -->
                  <section>
                      <button  type="button" class="btn btn-success" data-toggle="modal" data-target="#addUserModal">
                          Add user
                      </button>
                  </section>             																							
			</div>     
				<div class="rounded shadow border border-light p-2">
					<table class="table table-borderless table-responsive-sm" id="usersTable">
							<thead >
								<tr>
									<th scope="col">Name</th>
									<th scope="col">phone number</th>
									<th scope="col">location</th>                									          
									<th scope="col"></th>                        
								</tr>
							</thead>                    
							<tbody v-if="users && users.length">
								<tr v-for="(user,index) in users" :key="index">
									<td>{{user.first_name}} {{user.last_name}}</td>
									<td>{{user.phone_number}}</td>
									<td>{{user.loc_id | location(locations)}}</td> 									                         
									<div class="p-3">
										<a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </a>										
										<span class="dropdown-menu">
											<button  type="button" class="dropdown-item" data-toggle="modal" data-target="#permissionModal"
												@click="selectUser(user)">
												<vue-fontawesome class="cursor-pointer" icon="shield"></vue-fontawesome> Manage permissions													
											</button>
											<button  type="button" class="dropdown-item" data-toggle="modal" data-target="#editUserModal"
												@click="selectUser(user)">
												<vue-fontawesome class="cursor-pointer" icon="pencil"></vue-fontawesome> Edit user
											</button>
											<button class="dropdown-item text-danger" @click="deleteUser(user)">
												<vue-fontawesome icon="trash-o"></vue-fontawesome> Delete
											</button>
										</span>										                                    										
									</div>   
								</tr>                       
							</tbody>
					</table>
					<div class="p-3 d-flex justify-content-center"
						v-if="users && ! users.length">
						No records to show
					</div>
					<div class="p-3 d-flex justify-content-center"
						v-if="! users">
						<div class="spinner-border p-3 m-5" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
			</div> 
          </div>
      </section>        
      <!-- add user -->
      <section>                                                
          <div class="modal fade" id="addUserModal" tabindex="-1" role="dialog" aria-labelledby="addUser" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalCenterTitle">Add user</h5>
                  <button type="button" id="closeAddUserModal" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <form id="addUserForm">
                  <div class="modal-body">                    
						<div class="p-3 d-flex justify-content-between">
							<label class="font-weight-bold">first name</label>
							<input type="text" class="col-8 form-control" v-model="user_to_add.first_name" required>
						</div>    
						<div class="p-3 d-flex justify-content-between">
							<label class="font-weight-bold">last name</label>
							<input type="text" class="col-8 form-control" v-model="user_to_add.last_name" required>
						</div>                 
						<div class="p-3 d-flex justify-content-between">
							<label class="font-weight-bold">phone number</label>
							<input type="text" maxlength="10" minlength="10" class="col-8 form-control" v-model="user_to_add.phone_number">
						</div>                                                        
						<div class="p-3 d-flex justify-content-between">
							<label class="font-weight-bold">location</label>
							<select class="col-8 form-control" v-model="user_to_add.loc_id" required>
								<option v-for="(location,index) in locations" :key="index" :value="location.id">
									{{location.name}}
								</option>
							</select>
						</div>
                  </div>
                  <div class="modal-footer">                            
                      <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                      <button type="submit" class="btn btn-success"
                          @click="addUser()">                                                        
                          Add user
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
                      </button>
                  </div>
              </form>                
              </div>
          </div>
          </div>
      </section>
      <!-- edit user. -->
      <section>
			<!-- edit user -->
			<div class="modal fade" id="editUserModal" tabindex="-1" role="dialog" aria-labelledby="editUserModal" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document" v-if="user">
                  <div class="modal-content">
                  <div class="modal-header border-0">
                      <h5 class="modal-title" id="exampleModalCenterTitle">{{user.name}}</h5>
                      <button type="button" id="closeEditUserModal" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <form id="editUserForm">
                      <div class="modal-body">                    
							<div class="p-3 d-flex justify-content-between">
								<label class="font-weight-bold">first name</label>
								<input type="text" class="col-8 form-control" v-model="user.first_name" required>
							</div>    
							<div class="p-3 d-flex justify-content-between">
								<label class="font-weight-bold">last name</label>
								<input type="text" class="col-8 form-control" v-model="user.last_name" required>
							</div>                 
							<div class="p-3 d-flex justify-content-between">
								<label class="font-weight-bold">phone number</label>
								<input type="text" minlength="10" maxlength="10" class="col-8 form-control" v-model="user.phone_number">
							</div>                                                        
							<div class="p-3 d-flex justify-content-between">
								<label class="font-weight-bold">location</label>
								<select class="col-8 form-control" v-model="user.loc_id" disabled>
									<option v-for="(location,index) in locations" :key="index" :value="location.id">
										{{location.name}}
									</option>
								</select>
							</div>
                      </div>
                      <div class="modal-footer border-0">                            
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                          <button type="submit" class="btn btn-success"
                              @click="editUser()">                                                        
                              Edit user
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
                          </button>
                      </div>
                  </form>                
                  </div>
              </div>
			</div>
			<!-- manage permissions -->
			<div class="modal fade" id="permissionModal" tabindex="-1" role="dialog" aria-labelledby="permissionModal" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-lg" role="document" v-if="user">
					<div class="modal-content">
						<div class="modal-header border-0">
							<h5 class="modal-title" id="exampleModalCenterTitle">Permissions for {{user.first_name}} {{user.last_name}}</h5>
							<button type="button" id="closeEditUserModal" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
							</button>
						</div>         
						<div class="modal-body">     
								<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">								
									<li class="nav-item">
										<a class="nav-link active" id="pills-access-permissions" data-toggle="pill" href="#pills-access" role="tab" aria-controls="pills-access" aria-selected="true">Access permissions</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" id="pills-reports-permissions" data-toggle="pill" href="#pills-permissions" role="tab" aria-controls="pills-permissions" aria-selected="false">Report Permissions</a>
									</li>
								</ul>
								<div class="tab-content" id="pills-tabContent">	
									<div class="tab-pane fade show active" id="pills-access" role="tabpanel" aria-labelledby="pills-access-permissions">																				
										<div class="d-flex flex-wrap">											
											<div class="form-check col-4" v-for="(permission,index) in permissions" :key="index">
												<input class="access-permission form-check-input" type="checkbox" 
													:id="permission.name"
													:permission_code = "permission.code"																								
													:checked="permission.has_permision" >
												<label class="form-check-label" for="defaultCheck1">
													{{$slugify(permission.name)}}										
												</label>
											</div>   
										</div>																
									</div>								
									<div class="tab-pane fade" id="pills-permissions" role="tabpanel" aria-labelledby="pills-reports-permissions">									
										<div class="d-flex flex-wrap">											
											<div class="form-check col-4" v-for="(permission,index) in report_permissions" :key="index">
												<input class="report-permission form-check-input" type="checkbox" 
													:id="permission.name"
													:permission_code = "permission.code"																								
													:checked="permission.has_permision" >
												<label class="form-check-label" for="defaultCheck1">
													{{$slugify(permission.name)}}										
												</label>
											</div>  
										</div>
									</div>
								</div>
						</div>
						<div class="modal-footer border-0">
							<button type="button" id="closeEditPermissionModal" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-success"
								@click="updateAccessPermissions();updateReportPermissions()">                                                        
								update permissions
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
							</button>
						</div> 
					</div>
				</div>
			</div>
      </section>
  </div>
</template>
<script>
export default {
	name: 'customera',
	props: {
		msg: String
	},
	data(){
		return{
		users:null,	
		locations:null,			
		//selected user
		user: {},  				                            
		user_permissions: [],
		new_access_permission: "null",
		new_reports_permission: "null",
		//add expense
		user_to_add:{},
		adding : false,            
		}
	},
	mounted(){        
		this.getUsers()  
		this.getLocations()
	},
	computed:{
		account_switched(){
			return this.$store.state.account_switch_count
		},
		permissions: function(){
			var permissions = []
			var entries = Object.entries(this.$access_codes)
			for (var [name,code] of entries){
				permissions.push(
					{
						"name": name,
						"code": code,						
						"has_permision": this.$hasPermission(this.user.authorizationCode,code) || false
					}		
				)
			}
			return permissions
		},
		report_permissions: function(){
		var permissions = []
		var entries = Object.entries(this.$report_codes)
		for (var [name,code] of entries){
			permissions.push(
				{
					"name": name,
					"code": code,						
					"has_permision": this.$hasPermission(this.user.reportsAuthorizationCode,code) || false
				}		
			)
		}
		return permissions
	}
	},
	watch:{
		account_switched: function(){
			this.getUsers()  
			this.getLocations()
		},
	},
	methods:{
		//get_products
		getUsers: function(){                        
			this.$http({
				method:'get',				
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/users/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},            
			}).then((response)=>{
				this.users = response.data
			}).catch((err)=>{
				this.$emit('alert',err)
			})
		},
		// select user to edit or view
		selectUser: function(user){
			this.user = user
		},
		updateAccessPermissions(){			
			this.user_permissions = []	
			var checkboxes = document.getElementsByClassName('access-permission')						
			for (var checkbox of checkboxes){							
				this.user_permissions.push({
					"code": checkbox.getAttribute('permission_code'),
					"value": checkbox.checked
				})
			}			
			var selected_permissions = this.user_permissions.filter((p)=>{
				return p.value == true
			})			
			this.new_access_permission = this.$newPermissionCode(Object.values(selected_permissions))
			this.user.authorizationCode = this.new_access_permission
			this.editUser()			
		},
		updateReportPermissions(){			
			this.user_permissions = []	
			var checkboxes = document.getElementsByClassName('report-permission')						
			for (var checkbox of checkboxes){							
				this.user_permissions.push({
					"code": checkbox.getAttribute('permission_code'),
					"value": checkbox.checked
				})
			}			

			var selected_permissions = this.user_permissions.filter((p)=>{
				return p.value == true
			})			
			this.new_reports_permission = this.$newPermissionCode(Object.values(selected_permissions))
			this.user.reportsAuthorizationCode = this.new_access_permission
			this.editUser()
		},
		//add user.
		//locations types for when adding
		getLocations: function(){                            
			this.$http({
				method:'get',				
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},                
			}).then((response)=>{
				this.locations = response.data
			}).catch((err)=>{
				this.$emit('alert',err)
			})
		},
		addUser: function(){
          var is_valid = document.getElementById('addUserForm').checkValidity()
          if(is_valid){
			this.adding = true
			this.user_to_add.authorizationCode = "9223372036854775807"			  
			this.user_to_add.passwordDigest = "initialpassword"
			this.$http({
				method:'post',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/user/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},   
				data:this.user_to_add            
			}).then(()=>{
				this.adding = false
				document.getElementById('closeAddUserModal').click()
				this.getUsers()
			}).catch((err)=>{
				this.adding = false
				alert(err)
			})                
          }
      },
		//edit user
		editUser: function(){
			var is_valid = document.getElementById('editUserForm').checkValidity()
			if(is_valid){
			this.adding = true
			this.$http({
				method:'put',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/user/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
				data:this.user
			}).then(()=>{
				this.adding = false
				document.getElementById('closeEditUserModal').click()
				document.getElementById('closeEditPermissionModal').click()
				this.getUsers()
			}).catch((err)=>{
				this.adding = false
				alert(err)
			})
          }
		},
		//delete
		deleteUser: function(user){			
			var confirmed = confirm(`Do you want to delete ${user.first_name} ${user.last_name} from system ?`);
			if (confirmed) {
				this.$http({
					method:'delete',				
					url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/user/${user.id}/`,
					headers:{
						Authorization: JSON.parse(localStorage.getItem('auth_token'))
					},            
				}).then(()=>{
					this.getUsers()
				}).catch((err)=>{
					alert(err)
				})
			}
		}
    }
}
</script>